import { RegisteredComponent } from "@builder.io/sdk-react";
import { DLD_FIELD, DLT_FIELD } from "../../commonFields";

export const swdcInternalSearchTopFilterBlockConfig: Omit<
  RegisteredComponent,
  "component"
> = {
  name: "SWDC Internal Search Top Filter",
  noWrap: true,
  hideFromInsertMenu: process.env.SITE !== "swdc",
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderComponents: true,
    builderContext: true,
    builderLinkComponent: true,
  },
  inputs: [
    {
      name: "tabs",
      type: "list",
      required: false,
      helperText:
        "Configure the filter tabs (Products, Resources, Government, Everything)",
      defaultValue: [
        {
          label: "Products",
          filterGroup: "products",
          dlt: "Internal Search Top Filter",
          dld: "Products",
        },
        {
          label: "Resources",
          filterGroup: "resources",
          dlt: "Internal Search Top Filter",
          dld: "Resources",
        },
        {
          label: "Government",
          filterGroup: "government",
          dlt: "Internal Search Top Filter",
          dld: "Government",
        },
        {
          label: "Everything",
          filterGroup: "everything",
          dlt: "Internal Search Top Filter",
          dld: "Everything",
        },
      ],
      subFields: [
        {
          name: "label",
          type: "string",
          required: true,
          localized: true,
          helperText: "Display label for the tab",
        },
        {
          name: "filterGroup",
          type: "string",
          required: true,
          helperText:
            "Filter group identifier (products, resources, government, everything)",
        },
        {
          ...DLT_FIELD,
          name: "dlt",
          friendlyName: "Tab DLT",
          defaultValue: "tab",
        },
        {
          ...DLD_FIELD,
          name: "dld",
          friendlyName: "Tab DLD",
          helperText:
            "Data link detail for analytics (e.g., 'search filter products')",
        },
      ],
    },
  ],
  defaultStyles: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    flexShrink: "0",
    boxSizing: "border-box",
    marginTop: "40px",
    marginBottom: "40px",
  },
  canHaveChildren: false,
};
